module.exports = __webpack_public_path__ + "img/qfxcinemas_dark.1ab84277.jpg";